import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { getProductsAndPlans, clearProductsError } from "./actions";
import { productNames } from "../../constants/appData";
import Storefront from "../Storefront";
import InvalidCoupon from "./../InvalidCoupon";
import "./styles.css";

export class LandingContainer extends Component {
  state = {};

  componentDidMount() {
    this.props.getProductsAndPlans();
  }

  componentWillUnmount() {
    if (this.props.error.status) {
      this.props.clearProductsError();
    }
  }

  render() {
    return this.props.error.status === 404 ? (
      <InvalidCoupon />
    ) : (
      <Storefront
        productCode={this.props.productCode}
        productName={productNames[this.props.productCode]}
        products={this.props.subscriptionPlans}
      />
    );
  }
}

export const mapStateToProps = (state) => ({
  productCode: state.productInfo.productCode,
  subscriptionPlans: state.subscription.subscriptionPlans,
  error: state.subscription.error,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getProductsAndPlans,
      clearProductsError,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(LandingContainer);
